import NumberInput from '@wandb/weave/common/components/elements/NumberInput';
import React, {useCallback, useState} from 'react';

import {useDebouncedValue} from '../../../../../util/useDebouncedValue';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const MaxRowCount = () => {
  const {config, updateConfig} = useMediaSettingsDrawerContext();
  const updateConfigCallback = useCallback(
    (value: number) => {
      updateConfig({maxYAxisCount: value});
    },
    [updateConfig]
  );

  const {
    value: debouncedMaxRowCount,
    debouncedSetValue: debouncedUpdateConfig,
  } = useDebouncedValue<number>(
    config.maxYAxisCount,
    500,
    updateConfigCallback
  );

  const [maxRowCount, setMaxRowCount] = useState(debouncedMaxRowCount);

  const onChangeInput = (value?: number) => {
    if (value != null) {
      setMaxRowCount(value);
      debouncedUpdateConfig(value);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <SettingTitle title="Rows" />
      <div data-test="max-row-count-input">
        <NumberInput
          min={0}
          max={50}
          strideLength={1}
          value={maxRowCount}
          onChange={onChangeInput}
          stepper
          useStepperPlusMinus
        />
      </div>
    </div>
  );
};
